import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "accordion mb-5 bg-transparent",
  id: "kt_accordion_1"
}
const _hoisted_2 = { class: "accordion-item bg-transparent border-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header bg-transparent",
  id: "kt_accordion_1_header_1"
}, null, -1)
const _hoisted_4 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_5 = { class: "accordion-body bg-body lh-lg text-gray-700" }
const _hoisted_6 = { class: "h1 mb-4" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "m-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "h1 mt-10 mb-3" }
const _hoisted_11 = { class: "demo-collapse p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agency = _resolveComponent("agency")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.translate("Cooperation in the sale of Inboxino?")), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.translate(
                "You must have heard the phrase Affiliate Marketing or cooperation in sales. Thanks to the expansion of the Internet and online sales on various sites and social networks, this type of marketing has become very prosperous. This way of selling enables people and businesses to participate in the profits of a company's products without having the costs of production, support, after-sales service, rent, salaries, taxes and many hidden costs of a business. . Since Inboxino is a web-based software whose revenue model is subscription sales, and since WhatsApp has the highest usage rate in Iran and in many countries of the world, the advantage of being a representative of the Inboxino brand or cooperation Selling this popular product can be attractive for all people or businesses."
              )), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.translate(
                  "1- Selling through introducing the product in this model, you use the facilities you have at your disposal, such as communication, social networks, advertising, etc., to sell shares using the link and panel provided by Inboxino. You can start advertising right now. As you can see, each of the users of Inboxino has a unique link that anyone who registers in Inboxino through this link or registers the numerical code related to you during registration, will be known as a user under your collection and you can View the details of all transactions, customers and the amount of your profit from the sale in real time and make a request to settle the amount charged in your wallet. In this case, the profit for each package purchase will be 15% of the amount paid by the customer and 7% in case of renewal. In this method, there is no need to pay any money and from now on you can be one of the hundreds of Inboxino sales agents around the world."
                )), 1),
            _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.translate(
                  "2- Obtaining an official representative from Inboxino is for businesses that have high monthly sales and will be provided with more profit than the first method. To get an official agency, click on the link below and complete the relevant form so that our experts will contact you as soon as possible to explain the conditions and technical and financial characteristics of the agency."
                )), 1)
          ]),
          _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.translate("Frequently asked questions")), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_collapse, {
              modelValue: _ctx.activeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
              accordion: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, {
                  title: _ctx.translate('How can I send a proxy request?'),
                  name: "1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_agency)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_el_collapse_item, {
                  title: _ctx.translate('How do I advertise?'),
                  name: "2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.translate("Soon ....")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_el_collapse_item, {
                  title: _ctx.translate('How is profit calculated?'),
                  name: "3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.translate("Soon ....")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_el_collapse_item, {
                  title: _ctx.translate('How can I withdraw from my account?'),
                  name: "4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.translate("Soon ....")), 1)
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}